import request from '@/utils/request'

// 首页数据
export function homeadmin(params) {
  return request({
    url: '/agent/index/data',
    method: 'get',
    params
  })
}

// 采购排名
export function buyerList(params) {
  return request({
    url: '/agent/index/top/buyer',
    method: 'get',
    params
  })
}
//出货排名
export function supplierList(params) {
  return request({
    url: '/agent/index/top/supplier',
    method: 'get',
    params
  })
}

// 获取使用指南列表
export function newList(params) {
  return request({
    url: '/operate/system/newList',
    method: 'get',
    params
  })
}

// 修改已读状态
export function readingNotes(params) {
  return request({
    url: '/message/readingNotes',
    method: 'get',
    params
  })
}

// 问题反馈
export function feedback(data) {
  return request({
    url: '/operate/workorder/feedback',
    method: 'post',
    data
  })
}

// 获取二维码
export function getQRCode(params) {
  return request({
    url: '/operate/getQRCode',
    method: 'get',
    params
  })
}

// 获取logo
export function backDetailsView(params) {
  return request({
    url: '/oem/backDetails',
    method: 'get',
    params
  })
}


